module.exports = __webpack_public_path__ + "img/restore.cbfc4568.svg";